import { render, staticRenderFns } from "./ns-orders-preview-popup.vue?vue&type=template&id=d0eaaf80&"
import script from "./ns-orders-preview-popup.vue?vue&type=script&lang=js&"
export * from "./ns-orders-preview-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports